module.exports = __webpack_public_path__ + "img/convivio2022.ad8ae374.png";